'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/**
*/

module.exports = Object.assign({}, require('./watch-notifications'), {

    /**
    */

    onCreateModel: function onCreateModel(model) {
        model.notifier = this.notifier;
    },


    /**
    */

    getQuery: function getQuery() {
        return {};
    },


    /**
     */

    notify: function notify(message) {
        if (message.apiEndpoints !== this.apiEndpoints || !/response/.test(message.type)) return;
        if (!/insert|update|remove/.test(message.requestMessage.type)) return;

        // In the `/upload` endpoint, we always resolve the API response even if
        // it was unsuccessful.  Checking if the data is actually an error here
        // prevents making another HTTP call when the upload endpoint fails.
        if (message.data instanceof Error) return;

        // just reload. Any caching should be done by the service layer.
        this.load();
    },


    /**
    */

    load: function load(onLoad) {
        if (!onLoad) onLoad = function onLoad() {};

        this.setProperties({
            'error': void 0,
            'loading': true
        });

        var beforeOnLoad = function (error, data) {

            if (!error) {
                this.setProperties({
                    data: data
                });
            }

            this.setProperties({
                'error': error,
                'loading': false
            });

            onLoad.apply(this, arguments);
        }.bind(this);

        return Promise.resolve(this.notifier.notify({
            type: 'load',
            multi: true,
            apiEndpointAlias: this.apiEndpointAlias,
            target: this,
            query: this.getQuery()
        })).then(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 1),
                data = _ref2[0];

            beforeOnLoad(void 0, data);
        }, beforeOnLoad);
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/models/mixins/collection.js
 ** module id = 510
 ** module chunks = 0 1
 **/